import { Typography } from "@mui/material";
import type { FC } from "react";
import { Trans } from "react-i18next";
import type { Asset } from "./server/digital-asset-service";
import type { Folder } from "./server/folder-service";

export const AssetCount: FC<{ assets: Asset[]; folders: Folder[]; searchText?: string }> = ({
  assets,
  folders,
  searchText,
}) => {
  return (
    <Typography variant="h6">
      {folders.length > 0 ? (
        <>
          <Trans i18nKey="folderCount" values={{ count: folders.length }}>
            placeholder
          </Trans>
          {", "}
        </>
      ) : (
        ""
      )}
      <Trans i18nKey="assetCount" values={{ count: assets.length }}>
        placeholder
      </Trans>
      {searchText ? ` found for "${searchText}"` : ""}
    </Typography>
  );
};
